import { html, render } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { Dialog } from '@vaadin/vaadin-core'
import { View } from '../view'
import { DeviceListStore, DeviceStore } from '../../stores'
import { inject, Symbols } from '../../di'
import { validateAll } from '../../vaadin'

const closeIcon = html`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`
const alertIcon = html`<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`

@customElement('kob-device-create')
export class DevicesCreate extends View {

    @inject(Symbols.stores.deviceList)
    devicesList: DeviceListStore

    @property({ type: Object })
    deviceStore: DeviceStore

    @property()
    dialogOpened

    formRoot

    render() {
        return html`
            <vaadin-dialog
                aria-label="Create new device"
                overlay-class="kob-modal"
                .opened="${this.dialogOpened}"
                @opened-changed="${(e: CustomEvent) => (this.dialogOpened = e.detail.value)}"
                .renderer="${this.renderContent}"
            ></vaadin-dialog>
        `
    }

    handleCancel = () => this.dialogOpened = false

    handleSave = async () => {
        validateAll(this.formRoot)
        if (await this.deviceStore.save())
            this.dialogOpened = false
    }
    handleDelete = async () => {
        await this.deviceStore.remove()
        this.dialogOpened = false
    }

    handleNameInput = (e) => this.deviceStore.pending.name = e.target.value
    handleTypeInput = (e) => {
        this.deviceStore.pending.type = e.target.value
        this.renderContent(this.formRoot)
    }

    renderContent = (root: HTMLElement, dialog?: Dialog) => {
        this.formRoot = root
        const disableDelete = this.deviceStore.isNew || !this.deviceStore.canDelete
        render(
            html`
                <div class="kob-dialog">
                    <div class="modal-head">
                        <h3 class="modal-title">${this.deviceStore.isNew ? 'Add a device' : 'Edit device'}</h3>
                        <button class="modal-close" aria-label="Close" @click="${this.handleCancel}">${closeIcon}</button>
                    </div>
                    <div class="modal-body">
                        <vaadin-text-field label="Name"
                            required
                            value=${this.deviceStore.name}
                            @input=${this.handleNameInput}
                        ></vaadin-text-field>
                        <vaadin-select label="Device type"
                            required
                            .items="${this.devicesList.deviceTypes}"
                            value=${this.deviceStore.type}
                            @change=${this.handleTypeInput}
                        ></vaadin-select>
                        ${this.deviceStore.isUnsupported ? html`
                            <div class="modal-banner danger">
                                ${alertIcon}
                                <div>This model's hardware can't run the Koblime sync app. Syncing won't work.</div>
                            </div>
                        ` : ''}
                    </div>
                    <div class="modal-foot">
                        <button class="btn btn-danger btn-sm" ?disabled=${disableDelete} @click="${this.handleDelete}">Delete</button>
                        <div class="right-group">
                            <button class="btn btn-ghost btn-sm" @click="${this.handleCancel}">Cancel</button>
                            <button class="btn btn-primary btn-sm" @click="${this.handleSave}">Save</button>
                        </div>
                    </div>
                </div>
            `,
            root
        )
    }
}
